@if (_hasRight) {
  <div class="col-md-12 px-md-0">
    <cap-form-row class="mb-0">
      <div class="titleContainer col-md-12">
        <ng-content select=".cap-list-loader-title"></ng-content>
      </div>
      @if (showZeilenSelect && listLoader) {
        <cap-form-control column-classes="col-md-1,col-md-2" labelKey="Zeilen">
          <select [(ngModel)]="listLoader.pageSize" class="form-control" id="Zeilen" required type="number">
            @for (size of listLoader?.availablePageSizes; track size) {
              <option>{{ size }}</option>
            }
          </select>
        </cap-form-control>
      }
    </cap-form-row>
  </div>
  @if (!listLoader || listLoader?.isInitialLoading) {
    <cap-spinner-small></cap-spinner-small>
  }
  @if (listLoader?.allDataLoadedNoItemsFound) {
    <div class="mb-2">
      <span>{{ keineTranslateKey | translate }}</span>
    </div>
  }
  @if (listLoader?.isInitializedItemsFound) {
    <div [class.cap-list-loader-loading]="listLoader?.isPageLoading" class="my-2">
      <ng-content select=".cap-list-loader-content"></ng-content>
      <div [class.cap-list-loader-overlay]="listLoader?.isPageLoading"></div>
    </div>
  }
  <div class="container">
    <div class="row justify-content-center">
      @if (listLoader?.pagerData.totalPages > 1) {
        <div class="col-md-auto my-auto">
          <ngb-pagination
            (click)="currentPageChangeEventEmit()"
            (pageChange)="listLoader?.changePage($event)"
            [collectionSize]="listLoader?.pagerData.totalItems"
            [maxSize]="10"
            [page]="listLoader?.pagerData.currentPage"
            [pageSize]="listLoader?.pagerData.pageSize">
          </ngb-pagination>
        </div>
      }
      @if (showTotal && (listLoader?.isPageLoading || listLoader?.allDataLoadedItemsFound)) {
        <div class="col-md-auto my-auto">
          {{ "total" | translate }}: {{ listLoader?.pagerData.totalItems }}
          @if (listLoader?.pagerData.totalItems === 1) {
            {{ "Eintrag" | translate }}
          } @else {
            {{ "Eintraege" | translate }}
            @if (listLoader?.totalItemsVisible < listLoader?.totalItemsFound) {
              {{ " " }} {{ "von" | translate }} {{ listLoader?.totalItemsFound | decimalHochkomma }}
            }
          }
        </div>
      }
      <div class="col-md-auto my-auto">
        @if (listLoader) {
          <div class="container">
            @if (listLoader.state === loadingState.INFINITE_LOADING) {
              <div class="row">
                <div class="col" style="text-align: center">
                  <button (click)="listLoader.suspend()" class="btn btn-white buttonGroup" container="body" type="button">
                    <i class="fas fa-spinner fa-lg fa-fw fa-spin spinner"></i>
                    {{ "component.tablewrapper.suspend" | translate }}
                  </button>
                </div>
              </div>
            }
            @if (listLoader.state === loadingState.SUSPENDED) {
              <div class="row">
                <div class="col" style="text-align: center">
                  <button (click)="listLoader.resume()" class="btn btn-white buttonGroup" container="body" type="button">
                    {{ "component.tablewrapper.resume" | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row justify-content-center">
      @if (listLoader?.isSuspended) {
        <div class="col-md-auto my-auto">
          <small class="m-3">{{ "component.tablewrapper.nichtVollstaendigGeladen" | translate }}</small>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="mb-2">
    <span>{{ defaultText | translate }}</span>
  </div>
}
